import "../../../resources/less/Troubadour/Pathway/PaidFeatureInfoPopup.less";
import MultiPanelsNanoPopup from "../../components/Popups/MultiPanelsNanoPopup";
import Paywall from "./Paywall";
import { IPaywallPopup } from "./IPaywallPopup";
import RestPromise from "../../utils/RestPromise";

export default class TroubadourPaywallPopup
  extends MultiPanelsNanoPopup
  implements IPaywallPopup
{
  private activationCodeInput: JQuery<HTMLInputElement>;
  private codeCorrect: boolean = false;
  constructor() {
    super({
      target: ".js-paywall-popup",
      isPaywall: true,
      willOpen: () => {
        if (Paywall.instance.currentlyDisplayedPopup) {
          Paywall.instance.currentlyDisplayedPopup.Hide(false, true, true);
        }
      },
      onHide: () => {
        if (Paywall.instance.currentlyDisplayedPopup) {
          Paywall.instance.currentlyDisplayedPopup.Show();
        }
        if (this.codeCorrect) {
          location.reload();
        }
      },
    });

    this.activationCodeInput = $("input.activation-code");

    $(".js-use-activation-code").on("click", () => {
      this.goTo(1);
    });

    $(".js-cancel-activation-code").on("click", () => {
      this.goTo(0);
    });

    $(".js-confirm-activation-code-btn").on("click", () => {
      this.checkCode();
    });

    this.activationCodeInput.on("change", () => {
      this.showError("");
    });
  }

  public get featureName(): string {
    return this.currentTarget.attr("data-feature-name");
  }

  public set featureName(value: string) {
    this.currentTarget.attr("data-feature-name", value);
  }

  private checkCode() {
    const code = this.activationCodeInput.val();
    if (code) {
      RestPromise.Create("/rest/licence/code", "POST", { code: code })
        .then(() => {
          const redirectURL = $(".js-activation-code-container").attr(
            "data-redirect-url",
          );
          window.location.href = redirectURL;
          this.codeCorrect = true;
        })
        .catch((error: { responseData: { message: string } }) => {
          this.showError(error.responseData.message);
        });
    }
  }

  private showError(error: string) {
    $(".error-message").text(error);
  }
}
